import { IsBoolean, IsNotEmpty, IsNumber, IsOptional, IsString } from 'class-validator'
import 'reflect-metadata'
import { Length } from '../enums/length.enum'
import { Reporting } from './reporting'

export class SaveUserPreference extends Reporting {
  @IsNumber()
  languageId!: number

  @IsString()
  @IsNotEmpty()
  defaultYieldUnit!: string

  @IsString()
  @IsNotEmpty()
  defaultAreaUnit!: string

  @IsString()
  @IsNotEmpty()
  defaultApplicationUnit!: string

  @IsNumber()
  @IsNotEmpty()
  geolocationRadius!: number

  @IsString()
  @IsNotEmpty()
  geolocationRadiusUnit!: Length

  @IsString()
  @IsNotEmpty()
  regionName!: string

  @IsBoolean()
  @IsNotEmpty()
  limitDisplay!: boolean

  @IsNumber()
  @IsOptional()
  campaignId?: number

  @IsBoolean()
  @IsNotEmpty()
  displayCloseCrops!: boolean
}
